import { makeStyles } from '@mui/styles';

const useStyle = makeStyles(() => {
    return {
        typo: {
            color: '#1a202c',
            fontFamily: '"Inter", "Helvetica Neue", "Arial", sans-serif',
            fontWeight: 700
        },
        link: {
            color: '#86C85D',
            textDecoration: 'none',
            fontWeight: 600,
            transition: 'all 0.2s ease',
            "&:hover": {
                color: "#6ba542",
                textDecoration: 'underline'
            }
        },
        page_login: {
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            // background: 'linear-gradient(135deg, #86C85D 0%, #6ba542 100%)',
            padding: '16px'
        },
        content_login: {
            backgroundColor: "white",
            width: '100%',
            maxWidth: '450px',
            textAlign: 'center',
            padding: '40px',
            borderRadius: '16px',
            boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
            position: 'relative',
            overflow: 'hidden',
            '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '5px',
                // background: 'linear-gradient(90deg, #86C85D 0%, #6ba542 100%)'
            }
        },
        form: {
            width: '100%',
            marginTop: '20px'
        },
        img: {
            width: '100%',
            height: 'auto',
            maxHeight: '80px',
            objectFit: 'contain',
            marginBottom: '20px'
        },
        button: {
            background: 'linear-gradient(135deg, #86C85D 0%, #6ba542 100%)',
            color: 'white',
            padding: '12px 32px',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: 600,
            textTransform: 'none',
            boxShadow: '0 4px 12px rgba(134, 200, 93, 0.4)',
            transition: 'all 0.3s ease',
            '&:hover': {
                boxShadow: '0 6px 16px rgba(134, 200, 93, 0.6)',
                transform: 'translateY(-2px)'
            },
            '&:active': {
                transform: 'translateY(0)'
            }
        }
    }
});

export default useStyle;